/* Shared Shopify cart transport. No preview endpoints or credentials. */
(()=>{
 'use strict';
 const config=window.WR_COMMERCE_CONFIG||{},root=(config.root||'/').replace(/\/?$/,'/');
 let busy=false,locked=[];
 const moneyFormatters=new Map();

 /* WR v50 — un seul formateur de prix pour tout le site.

    Le symbole n'est plus placé d'après la langue de la page : en anglais, Intl
    écrit « €12.99 », alors que la boutique affiche « 12,99 € » partout ailleurs
    et au paiement. La référence, c'est le format de la devise active côté
    Shopify. On le déduit d'un échantillon rendu en Liquid par le filtre money
    (1 234 567,89 dans la devise du marché en cours) : de cet échantillon on lit
    le symbole, son côté, l'espace éventuel, les séparateurs et le nombre de
    décimales, puis on applique ce gabarit à n'importe quel montant. Changement
    de devise ou de marché : l'échantillon change avec, et l'affichage suit.

    Intl ne sert plus que de secours si l'échantillon est absent (page servie
    sans le snippet de configuration). */

 /* WR v51 — le côté du symbole suit l'usage de la devise, pas le réglage de
    la boutique. Shopify livre l'euro en « €12,99 » par défaut alors qu'on
    écrit « 12,99 € » en France, en Allemagne, en Espagne, en Italie… Ces
    devises-là sont listées ici ; pour toutes les autres (dollar, livre, franc,
    yen…) l'échantillon Shopify fait foi et rien n'est déplacé. Seul le symbole
    bouge : séparateurs et décimales restent ceux de la boutique. */
 const symbolAfter='EUR SEK NOK DKK ISK PLN CZK HUF RON BGN HRK RSD UAH RUB KZT VND MAD TND'.split(' ');
 const trailing=code=>symbolAfter.indexOf(String(code||'').toUpperCase())>=0;
 /* Déplace le symbole d'un montant déjà formaté, en laissant le signe devant. */
 function moveSymbol(text){
  const first=text.search(/\d/);if(first<0)return text;
  const head=text.slice(0,first),sign=(head.match(/^[-−+\s]*/)||[''])[0];
  const symbol=head.slice(sign.length).trim();
  return symbol?sign.trim()+text.slice(first)+' '+symbol:text;
 }

 const moneyPattern=(()=>{
  const sample=String(config.moneySample||'').replace(/<[^>]*>/g,'').trim();
  const first=sample.search(/\d/);
  if(first<0)return null;
  let last=first;
  for(let i=sample.length-1;i>=0;i--){if(sample[i]>='0'&&sample[i]<='9'){last=i;break}}
  const core=sample.slice(first,last+1),separators=core.replace(/\d/g,'');
  const shell={prefix:sample.slice(0,first),suffix:sample.slice(last+1)};
  /* Aucun séparateur : montant brut, ni milliers ni décimales. */
  if(!separators)return Object.assign(shell,{decimals:0,decimalSeparator:'',groupSeparator:''});
  const decimalSeparator=separators[separators.length-1];
  const tail=core.slice(core.lastIndexOf(decimalSeparator)+1);
  /* Trois chiffres après le dernier séparateur et tous les séparateurs
     identiques : c'est un groupe de milliers, la devise n'a pas de décimales
     (yen, forint…). Sinon le dernier séparateur est bien le décimal. */
  const grouped=tail.length===3&&separators.split('').every(s=>s===decimalSeparator);
  return Object.assign(shell,{
   decimals:grouped?0:tail.length,
   decimalSeparator:grouped?'':decimalSeparator,
   groupSeparator:grouped?decimalSeparator:(separators.length>1?separators[0]:'')
  });
 })();

 /* Correction du côté : symbole devant alors que la devise le veut derrière. */
 if(moneyPattern&&trailing(config.currency)&&moneyPattern.prefix.trim()&&!moneyPattern.suffix.trim()){
  moneyPattern.suffix=' '+moneyPattern.prefix.trim();
  moneyPattern.prefix='';
 }

 function formatMoney(amount,currency=config.currency,locale=config.locale){
  const value=Number(amount);if(!Number.isFinite(value))return '';
  if(moneyPattern&&currency===config.currency&&locale===config.locale){
   const p=moneyPattern,sign=value<0?'-':'';
   const parts=Math.abs(value).toFixed(p.decimals).split('.');
   const whole=parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,p.groupSeparator);
   return sign+p.prefix+whole+(p.decimals?p.decimalSeparator+parts[1]:'')+p.suffix;
  }
  const code=/^[A-Z]{3}$/.test(String(currency))?currency:'EUR';
  const language=locale||document.documentElement.lang||'en';
  const key=language+'|'+code;
  if(!moneyFormatters.has(key)){
   try{moneyFormatters.set(key,new Intl.NumberFormat(language,{style:'currency',currency:code}))}
   catch{moneyFormatters.set(key,new Intl.NumberFormat('en',{style:'currency',currency:'EUR'}))}
  }
  const text=moneyFormatters.get(key).format(value);
  return trailing(code)?moveSymbol(text):text;
 }

 const t=(key,fallback)=>(config.messages||{})[key]||fallback;
 function url(path){return root+String(path).replace(/^\//,'')}
 async function request(path,options={}){
  const response=await fetch(url(path),{credentials:'same-origin',cache:'no-store',...options});
  if(!response.ok){let body={};try{body=await response.clone().json()}catch{}const error=new Error(body.description||body.message||t('retry','We could not update your cart. Please try again.'));error.status=response.status;throw error}
  return response;
 }
 function error(cause){
  let box=document.getElementById('wr-commerce-error');
  if(!box){box=document.createElement('div');box.id='wr-commerce-error';box.setAttribute('role','alert');box.setAttribute('tabindex','-1');box.innerHTML='<span></span><button type="button" aria-label="'+t('close','Close')+'">×</button>';document.body.append(box);box.querySelector('button').addEventListener('click',()=>box.hidden=true)}
  box.querySelector('span').textContent=cause?.status?cause.message:t('retry','We could not update your cart. Please try again.');box.hidden=false;
 }
 function lock(){if(busy)return false;busy=true;locked=[...document.querySelectorAll('#wrCta,#wrBuyNow,#wr-sb-co-d,#wr-sb-co-m,#wr-sb-atc-d,#wr-sb-atc-m,#wr-cd-btn-co,#wr-gc-co-btn')].map(el=>({el,disabled:el.disabled}));locked.forEach(({el})=>{el.disabled=true;el.setAttribute('aria-busy','true')});const box=document.getElementById('wr-commerce-error');if(box)box.hidden=true;return true}
 function unlock(){busy=false;locked.forEach(({el,disabled})=>{el.disabled=disabled;el.removeAttribute('aria-busy');el.style.opacity=''});locked=[]}
 function checkout(code){const checkout=url('checkout');return code?url('discount/'+encodeURIComponent(code))+'?redirect='+encodeURIComponent(checkout):checkout}

 /* Remise multi-eSIM : un seul réglage pour toute la boutique (Thème ›
    Paramètres › Remise multi-eSIM). La page produit, la barre d'achat et les
    deux paniers lisent ces trois fonctions ; aucun pourcentage n'est écrit
    ailleurs. La remise réelle est accordée par Shopify au paiement. */
 const bundle=config.bundle||{};
 const bundlePct=Math.max(0,Math.min(90,Number(bundle.pct)||0));
 const bundleMin=Math.max(2,parseInt(bundle.min,10)||2);
 const bundleCodeValue=String(bundle.code||'').trim();
 function bundleRate(quantity){return bundlePct>0&&(parseInt(quantity,10)||0)>=bundleMin?bundlePct/100:0}
 function bundleCode(quantity){return bundleCodeValue&&bundleRate(quantity)>0?bundleCodeValue:''}
 /* Paiement : le code n'est joint que si le panier remplit la condition. */
 function checkoutFor(quantity){return checkout(bundleCode(quantity))}

 /* Fixe la quantité d'une variante dans le panier (l'ajoute si absente) sans
    jamais l'additionner à une ligne existante : « Acheter maintenant » deux
    fois de suite ne double pas la commande. Renvoie le panier à jour. */
 async function ensure(variantId,quantity){
  quantity=Math.max(1,parseInt(quantity,10)||1);
  const cart=await (await request('cart.js')).json();
  const line=(cart.items||[]).find(item=>String(item.variant_id)===String(variantId));
  if(line&&line.quantity===quantity)return cart;
  const body=line?{id:line.key,quantity}:{id:variantId,quantity};
  await request(line?'cart/change.js':'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
  return (await request('cart.js')).json();
 }
 /* Nom de forfait lisible dans les paniers : les variantes Shopify s'appellent
    « 10GB 30Days (Popular) » ou « Unlimited for 7Days ». On retire l'étiquette
    marketing et on écrit volume et durée dans la langue de la page. */
 const VL={fr:['Illimité','jour','jours'],en:['Unlimited','day','days'],de:['Unbegrenzt','Tag','Tage'],es:['Ilimitado','día','días'],it:['Illimitato','giorno','giorni'],nl:['Onbeperkt','dag','dagen'],pt:['Ilimitado','dia','dias'],ja:['無制限','日','日'],ko:['무제한','일','일'],zh:['无限流量','天','天'],'zh-tw':['無限流量','天','天'],pl:['Bez limitu','dzień','dni'],sv:['Obegränsad','dag','dagar'],da:['Ubegrænset','dag','dage'],nb:['Ubegrenset','dag','dager'],no:['Ubegrenset','dag','dager'],fi:['Rajaton','päivä','päivää'],tr:['Sınırsız','gün','gün'],cs:['Neomezeně','den','dní'],ro:['Nelimitat','zi','zile']};
 function variantLabel(raw){
  const full=String(document.documentElement.lang||config.locale||'en').toLowerCase(),lang=full.slice(0,2),w=VL[full]||VL[lang]||VL.en,fr=lang==='fr';
  let t=String(raw||'').replace(/\s*\((?:popular|populaire|popolare|beliebt|populair|popular)\)\s*/ig,' ');
  const unl=/unlimited|illimit|ilimit|unbegrenzt|onbeperkt/i.test(t);
  const vol=t.match(/(\d+(?:[.,]\d+)?)\s*(GB|MB|Go|Mo)\b/i),day=t.match(/(\d+)\s*Days?\b/i);
  if(!vol&&!day&&!unl)return t.trim();
  const parts=[];
  if(unl)parts.push(w[0]);
  if(vol){const mb=/^m/i.test(vol[2]);parts.push(vol[1]+' '+(fr?(mb?'Mo':'Go'):(mb?'MB':'GB')))}
  if(day)parts.push(day[1]+' '+(day[1]==='1'?w[1]:w[2]));
  return parts.join(' · ');
 }
 window.WR_COMMERCE={fetch:request,url,error,lock,unlock,checkout,checkoutFor,formatMoney,ensure,variantLabel,bundle:{pct:bundlePct,min:bundleMin,rate:bundleRate,code:bundleCode}};
 addEventListener('pageshow',()=>unlock());
})();
